import { styled, Theme } from '@mui/material';
import { coreThemeColors } from '@youscience/theme';

export const sxStyles = {
  studentOutcomesContainer: {
    marginTop: '1.75rem',
  },
  studentOutcomesSectionTitle: (theme: Theme) => ({
    color: theme.palette.primary.main,
    marginBottom: '1.5rem',
  }),
  studentOutcomesSubtitle: (theme: Theme) => ({
    padding: '1.25rem 2rem',
    borderBottom: `1px solid ${theme.palette.grey['300']}`,
  }),
  outcomesTitle: {
    marginBottom: '1rem',
  },
  outcomesItemWrap: {
    '& > h5:first-of-type': {
      marginTop: '2px',
      marginBottom: '0.75rem',
    },
  },
  rateWrap: {
    display: 'flex',
    marginBottom: '1.5rem',

    '& > div:first-of-type': {
      marginRight: '0.625rem',
    },
  },
  rateInner: {
    width: '100%',
    backgroundColor: coreThemeColors.primary.outlinedHoverBackground,
  },
  earnings: {
    marginTop: '2.5rem',

    '& > div:first-of-type': {
      marginBottom: '2px',
    },
  },
  earningsCost: (theme: Theme) => ({
    color: theme.palette.primary.main,
  }),
};

export const StyledStudentOutcomesWrap = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  width: '100%',
  marginTop: '2.25rem',
  boxShadow: '0px 5px 25px rgba(17, 77, 76, 0.1)',
  borderRadius: '0.5rem',
}));

export const StyledStudentOutcomesInner = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  padding: '2.5rem 8rem 2.5rem 2.5rem',

  '& > div:first-of-type': {
    maxWidth: '328px',
    width: '100%',
    marginRight: '3rem',
  },

  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    padding: '2.5rem 2rem',

    '& > div:last-of-type': {
      marginLeft: 0,
      marginTop: '0.5rem',
    },
  },
}));

export const StyledFilledRate = styled('div', {
  shouldForwardProp: (prop) => prop !== 'filledRate',
})<{ filledRate: number }>(({ filledRate, theme }) => ({
  minHeight: '24px',
  width: `${filledRate}%`,
  backgroundColor: theme.palette.primary.main,
}));
